<template>
    <b-modal ref="mdlDbCompare" :title="title" size="lg" no-close-on-backdrop no-close-on-esc hide-header-close centered>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">DB Struttura</label>
                <b-form-select v-model="jsonData.dbStruttura" :options="dbStrutturaOptions">
                    <template #first>
                        <b-form-select-option :value="null" disabled>Seleziona opzione</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">DB HL7</label>
                <b-form-select v-model="jsonData.dbHl7" :options="dbhL7Options">
                    <template #first>
                        <b-form-select-option :value="null" disabled>Seleziona opzione</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">DB Thcs</label>
                <b-form-select v-model="jsonData.dbThcs" :options="dbThcsOptions">
                    <template #first>
                        <b-form-select-option :value="null" disabled>Seleziona opzione</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
        </b-row>

        <template #modal-footer>
            <b-button @click="onClickCloseModal" size="sm" variant="outline-danger">Annulla</b-button>
            <b-button size="sm" variant="outline-success">Salva</b-button>
            <!--  @click="onClickSaveDbCompare" -->
        </template>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            title: null,
            dbStrutturaOptions: [],
            dbhL7Options: [],
            dbThcsOptions: [],

            jsonData: {
                dbStruttura: null,
                dbHl7: null,
                dbThcs: null,
                stato: null,
            },
        };
    },
    methods: {
        show(jsonData) {
            let me = this;
            me.title = !jsonData.id ? "Nuovo DB Compare" : "Aggiorna DB Compare";
            me.$refs.mdlDbCompare.show();
        },

        onClickCloseModal() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlDbCompare.hide();
        },
    },
};
</script>
